var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertTriangle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99965 6.6657V9.99903M9.99965 13.3324H10.008M8.57465 2.38236L1.51632 14.1657C1.37079 14.4177 1.29379 14.7034 1.29298 14.9945C1.29216 15.2855 1.36756 15.5716 1.51167 15.8245C1.65579 16.0773 1.86359 16.288 2.11441 16.4356C2.36523 16.5832 2.65032 16.6625 2.94132 16.6657H17.058C17.349 16.6625 17.6341 16.5832 17.8849 16.4356C18.1357 16.288 18.3435 16.0773 18.4876 15.8245C18.6317 15.5716 18.7071 15.2855 18.7063 14.9945C18.7055 14.7034 18.6285 14.4177 18.483 14.1657L11.4247 2.38236C11.2761 2.13745 11.0669 1.93496 10.8173 1.79443C10.5677 1.6539 10.2861 1.58008 9.99965 1.58008C9.71321 1.58008 9.43159 1.6539 9.18199 1.79443C8.93238 1.93496 8.72321 2.13745 8.57465 2.38236Z",
    stroke: "#DC6803",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle);
export default __webpack_public_path__ + "static/media/alert-triangle.fb4952efef08abb3288c50187efd81e2.svg";
export { ForwardRef as ReactComponent };